import React from 'react';
import {CalendarOutlined, SwapOutlined} from "@ant-design/icons";
import { Button , Card } from 'antd';
import { useState } from 'react';
import { Calendar } from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import book_1 from '../assets/images/book_1.jpg'
import book_2 from '../assets/images/book_2.jpg'
import book_3 from '../assets/images/book_3.jpg'
import book_bg from '../assets/images/booking-bg.svg'

const BusBooking = () => {
  
  const [ isDateOpen , setIsDateOpen ] = useState(false);
  const [date, setDate] = useState(new Date());

  const onDateChange = (e) => {
    setDate(e);
    setIsDateOpen(false);
  }

  return (
   <>
       <Card className='booking__bg'>

       <h3 className="book_tickets">Book Bus Tickets</h3>

       <div className="book_bus">
          <div className="booking_bg">
            <div className="one_way">
                <div>
                  <input type='radio' id="" name='trip'></input>
                  <label for=''>One Way</label>
                </div>
               <div>
                  <input type='radio' id='' name='trip'></input>
                  <label for="">Round Trip</label>
               </div>
            </div>
            <div className="trip_inputs">
               <div className="trip_inputs_box">
                  <label>From : </label>
                 
                  <select>
                    <option selected disabled >Select</option>
                    <option value={'Delhi'}>Delhi</option>
                    <option value={'Pune'}>Pune</option>
                    <option value={'Mumbai'}>Mumbai</option>
                    <option value={'Agra'}>Agra</option>
                    <option value={'Mathura'}>Mathura</option>
                  </select>
               </div>              
                  <div class="center_icon">
                      <SwapOutlined />  
                  </div>
              <div className="trip_inputs_box">
                  <label>To : </label>
                  
                  <select>
                  <option selected disabled >Select</option>
                    <option value={'Delhi'}>Delhi</option>
                    <option value={'Pune'}>Pune</option>
                    <option value={'Mumbai'}>Mumbai</option>
                    <option value={'Agra'}>Agra</option>
                    <option value={'Mathura'}>Mathura</option>
                  </select>
              </div>                           
            </div>          
            <div className='tripdown_bttns'>
              <Card><p>Seat Type ( Optional )</p></Card>
                <div className="trip_bttns">
                  <Button>Seater</Button>
                  <Button>Sleeper </Button>
                  <Button>Semi-Sleeper</Button>
                </div>
                
            </div>
              <div className="check_box">
                  <Card><input type='checkbox'/><label>Show AC buses only</label></Card>
                </div>
        </div>
        <div className="booking_bg_right">
        <div className="one_way_right">
          <p>Departure Date</p>
            </div>
           
           <div className="booking_date">
           <Button onClick={() => setIsDateOpen(!isDateOpen)}><CalendarOutlined /> {date.toDateString()} </Button>
           {isDateOpen && <Calendar onChange={onDateChange} value={date} />}

           </div>
            
            <button className="search_bus"> Search Buses </button>
        </div>
        
       </div>
       
       </Card>

       <div className='booking_img_box'>
       <div className="booking_image">
          <Card> <img src={book_1} /> </Card>
      </div>
      <div className="booking_image">
          <Card> <img src={book_2} /> </Card>
      </div>
      <div className="booking_image">
          <Card> <img src={book_3} /> </Card>
      </div>
       </div>

  </>
  )
}



export default BusBooking